import { useMomentLocale } from '@lumapps/translations/hooks/useMomentLocale';
import {
    useRetrieveTranslations,
    type UseRetrieveTranslationsOptions,
} from '@lumapps/translations/hooks/useRetrieveTranslations';

import { useInitialState, type UseInitialStateOptions } from './useInitialState';

export type UseInitializeApplicationOptions = UseInitialStateOptions & UseRetrieveTranslationsOptions;

/**
 * Hook that will be executed to initialize the application. As for the moment, it executes:
 * - Listens to the init request
 * - Listens to the translations request.
 *
 * This hook only returns something when we have receive enough information to display on the page,
 * since both translations and the initial request are blocking for the page rendering. Only when both
 * values are populated, we return something to the page. If this logic changes (we want to execute something else but still render),
 * we will need to add a little bit more logic here.
 */
export const useInitializeApplication = (options?: UseInitializeApplicationOptions) => {
    const initialState = useInitialState(options);
    const translationsState = useRetrieveTranslations(options);

    useMomentLocale({ translations: translationsState });

    return initialState && translationsState ? { initialState, translationsState } : {};
};
